import { Component, OnInit } from '@angular/core';
import { PaypalManagementService } from '../../services/PaypalManagement.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Promoreturnmodal } from '../../models/PromoReturn.model';
import { PaypalPaymentModal } from '../../models/PaypalPayment.model';
import { TransactionModal } from '../../models/Transaction.model';
import { PaypalPaymentDoneModal } from '../../models/PaypalPaymentDone.model';
import { PaypalPaymentItemsModal } from '../../models/PaypalPaymentItems.model';
import { BuyProductsModal } from '../../models/BuyProducts.model';
import { BuyIpsProductReturn } from '../../models/BuyIpsProductReturn.model';
import { FinalProductPaymentModal } from '../../models/FinalProductPayment.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
//import { AlertMessages, AlertType } from '../../../../../core/AlertMessages'
import { error } from 'protractor';
import { stringify } from 'querystring';
import { PaypalTokenModel } from '../../models/PaypalToken.model';
import { JsonPipe } from '@angular/common';

import { MPaypalProduct } from '../../models/MPaypalProduct.model';
import { PayPalPlan } from '../../models/PaypalPlan.model';
import { Subscription } from 'rxjs';
declare let paypal: any;
declare var $: any;

@Component({
    selector: 'app-paypal-management-customer-info',
    templateUrl: './paypal-management-customer-info.component.html',
    styleUrls: ['./paypal-management-customer-info.component.css'],
})

export class PaypalManagementCustomerInfoComponent implements OnInit {
    productId: string = "";
    quantity: number = 1;
    amountWithDiscount: string = "0";
    emailId: string;
    mobileNo: string;
    promoId: string = "";
    totalAmount: number = 0;
    amountToBePaid: number = 0;
    initialAmount: number = 0;
    emailProcessing: boolean;
    customerName: string = "";
    hospitalName: string = "";
    customerAddress: string = "";
    emailIsValid: boolean;
    allProducts: any[] = [];
    paypalPlanSubscription: Subscription = null;
    product: any;
    emailReturn: any;
    promoReturn: Promoreturnmodal;
    promoFlag: boolean = false;
    promoName: string = "";
    confirmationMessageStatus: boolean = false;
    showSmallSpin: boolean = false;
    invoiceId;
    promoMessage: string = "";
    paypalPaymentData: PaypalPaymentModal;
    discountAmount: number = 0;
    addScript: boolean = false;
    addScriptReccur: boolean = false;
    paypalLoad: boolean = false;
    proceed: boolean = false;
    proceedBtnDisable: boolean = false;
    finalAmount: number = 1;
    transactionModal: TransactionModal;
    showOverlayBuyIpsThree: boolean = false;
    showAlert: boolean;
    confirmNotification: boolean = false;
    notificationText: string = "";
    notificationTextNote: string = "";
    paypalConfirmed: boolean = false;
    totalServiceCharge: number = 0;
    addOnArray: any[] = [];
    servicesAddOnLast: any[] = [];
    currentDate;
    currentDateOne;
    currentDateTwo;
    currentDateThree;
    buyIpsProductReturnFinal: BuyIpsProductReturn;
    buyProductFinal: BuyProductsModal[] = [];
    licenseCostLast: number = 0;
    staticSingleProductCostLast: number = 0;
    amountToPay: number = 0;
    subtotal: number = 0;
    paypalPaymentDone: PaypalPaymentDoneModal;
    taxPercentage: any;
    servicesCost: number = 0;
    discountProductModalDataFinal: Promoreturnmodal;
    taxCost: number = 0;
    addedServices: any[] = [];
    addonServiceComplete: any[] = [];
    addonArrayComplete: any[] = [];
    serviceAddedComplete: any;
    showLegalMoreMid: boolean = false;
    serviceCharges: string = "";
    discountAmountOne: number = 0;
    productTotalAmount: number = 0;
    subtotalAmount: number = 0;
    purchaseAmount: number = 0;
    trialAmount: number = 0;
    fixedAmount: number = 0;
    planId: string = "";
    recurringValue: boolean = true;
    planErrorMessage: string = "";
    canGoBack: boolean = true;
    constructor(private _service: PaypalManagementService, private _route: ActivatedRoute, private router: Router) { }
    ngOnInit() {
        this.planErrorMessage = "";
        this.licenseCostLast = 0;
        this.showLegalMoreMid = true;
        this.productTotalAmount = 0;
        this.paypalPaymentDone = new PaypalPaymentDoneModal();
        this.staticSingleProductCostLast = 0;
        this.currentDateOne = new Date().getDate();
        this.currentDateTwo = new Date().getMonth() + 1;
        this.currentDateThree = new Date().getFullYear();
        this.currentDate = this.currentDateThree + "-" + this.currentDateTwo + "-" + this.currentDateOne;
        this.recurringValue = true;
        this.confirmNotification = false;
        this.amountToPay = 0;
        this.subtotal = 0;
        this.taxPercentage = 0;
        this.servicesCost = 0;
        this.taxCost = 0;
        this.notificationText = "";
        this.transactionModal = new TransactionModal();
        this.paypalPaymentData = new PaypalPaymentModal();
        this.showOverlayBuyIpsThree = true;
        this.addOnArray = [];
        this.addonArrayComplete = [];
        this.serviceAddedComplete = [];
        this.buyProductFinal = [];
        this.discountProductModalDataFinal = new Promoreturnmodal();
        this.invoiceId = this.makeRandomId();
        this.buyIpsProductReturnFinal = new BuyIpsProductReturn();
        this.subtotalAmount = 0
        this.purchaseAmount = 0;
        this._route.queryParams.subscribe(params => {
            this.productId = params['productId'], this.quantity = params['productQty'], this.promoId = params['promoId'], this.promoName = params['promoName'], this.addOnArray = params['addOnService'], this.addonArrayComplete = params['addOnServiceComplete'], this.serviceCharges = params['serviceCompleted'], this.amountToPay = params['amountToPay'], this.subtotal = params['subTotal'], this.taxPercentage = params['taxPercentage'], this.servicesCost = params['servicesCost'], this.taxCost = params['taxCost'], this.discountAmountOne = params['discountAmount'], this.buyProductFinal = JSON.parse(params['BuyProductFinal']), this.discountProductModalDataFinal = JSON.parse(params['DiscountProductModalData']), this.productTotalAmount = params['productTotalAmount']
        });
        this.serviceAddedComplete = JSON.parse(this.serviceCharges);
        this.subtotalAmount = parseFloat(this.subtotal.toString()) + parseFloat(this.servicesCost.toString());
        this.purchaseAmount = parseFloat(this.productTotalAmount.toString()) + parseFloat(this.servicesCost.toString());
        this.buyIpsProductReturnFinal.products = this.buyProductFinal;
        this.buyIpsProductReturnFinal.discount = this.discountProductModalDataFinal;
        this.getSingleSelectedProduct(this.productId);

    }
    getSingleSelectedProduct(productId) {
        this._service.getProducts().subscribe((data: any[]) => {
            this.paypalPaymentDone = new PaypalPaymentDoneModal();
            this.allProducts = data;
            this.product = this.allProducts.filter(i => i.id == productId)[0];
            this.servicesAddOnLast = this.allProducts.filter(j => j.productType == 2);
            this.licenseCostLast = this.allProducts.filter(i => i.productType == 4)[0].amount == null ? 0 : this.allProducts.filter(i => i.productType == 4)[0].amount;
            let subTotal = 0;
            let subTotalCost = 0;
            subTotalCost = this.subtotal + this.servicesCost;
            subTotal = parseInt(this.subtotal.toString()) + parseInt(this.servicesCost.toString());
            let amountToPay = 0.00;
            let subTotalInside = 0.00;
            let discountInside = 0.00;
            let taxInside = 0.00;
            amountToPay = this.amountToPay;
            subTotalInside = subTotal;
            discountInside = this.discountAmountOne == null ? 0.00 : this.discountAmountOne == undefined ? 0.00 : this.discountAmountOne;
            taxInside = this.taxCost;
            let amountToPayOne = parseFloat(parseFloat(amountToPay.toString()).toFixed(2));
            let subtotalInsideOne = parseFloat(parseFloat(subTotalInside.toString()).toFixed(2));
            let discountInsideOne = parseFloat(parseFloat(discountInside.toString()).toFixed(2));
            let taxInsideOne = parseFloat(parseFloat(taxInside.toString()).toFixed(2));
            let shippingCharge = amountToPayOne - ((subtotalInsideOne + taxInsideOne) - discountInsideOne);
            this.staticSingleProductCostLast = this.licenseCostLast + (this.product.amount);
            this.paypalPaymentDone = {
                "intent": "sale",
                "payer": {
                    "payment_method": "paypal"
                },
                "transactions": [{
                    "amount": {
                        "currency": "USD",
                        "total": "" + parseFloat(this.amountToPay.toString()).toFixed(2),
                        "details": {
                            "subtotal": "" + parseFloat(subTotal.toString()).toFixed(2),
                            "shipping": "" + parseFloat(shippingCharge.toString()).toFixed(2),
                            "tax": parseFloat(this.taxCost.toString()).toFixed(2).toString(),
                            "shippingDiscount": "" + -parseFloat(discountInside.toString()).toFixed(2)
                        }
                    },
                    "description": "IPS PAYMENT",
                    "invoiceNumber": this.invoiceId,
                    "itemList": {
                        "items": [{
                            "sku": "sku",
                            "name": "IPS Licenses",
                            "quantity": "" + this.quantity,
                            "price": "" + parseFloat(this.licenseCostLast.toString()).toFixed(2),
                            "currency": "USD"
                        }]
                    }
                }]
            };

            var paypalitems: PaypalPaymentItemsModal = {
                "sku": "sku1",
                "name": 'Web Panel',
                "quantity": "1",
                "price": "" + parseFloat(this.product.amount.toString()).toFixed(2),
                "currency": "USD"
            };

            this.paypalPaymentDone.transactions[0].itemList.items.push(paypalitems);
            this.serviceAddedComplete.forEach(element => {
                var paypalItemsService: PaypalPaymentItemsModal = {
                    "sku": "sku1",
                    "name": element.productName,
                    "quantity": "" + element.qty,
                    "price": "" + parseFloat(element.amount.toString()).toFixed(2),
                    "currency": "USD"
                };
                this.paypalPaymentDone.transactions[0].itemList.items.push(paypalItemsService);
            });
            this.totalAmount = this.staticSingleProductCostLast;
            this.amountToBePaid = this.amountToPay;
            if (this.promoId == null || this.promoId == undefined || this.promoId == "") {
                this.promoFlag = false;
                this.totalAmount = this.licenseCostLast * this.quantity + (this.product.amount);
                this.amountToBePaid = this.licenseCostLast * this.quantity + (this.product.amount);
            } else {
                this.promoFlag = true;
                if (this.promoName !== null && this.promoName !== undefined && this.promoName !== "") {
                    this.applyPromoCode(this.promoName);
                }
            }
            this.showOverlayBuyIpsThree = false;
        });
    }
    // AlertClose() {
    //   setTimeout(() => {
    //     this.showAlert = false;
    //   }, 5000);
    // }
    // AlertCloseips() {
    //   setTimeout(() => {
    //     this.showAlert = false;
    //     this.showOverlayBuyIpsThree = false;
    //     this.transactionModal = new TransactionModal();
    //     this.paypalPaymentData = new PaypalPaymentModal();
    //     this.router.navigate(['BuyIPSProduct']);
    //   }, 2000);
    // }
    //
    applyPromoCode(promoCode) {
        if (promoCode == "" || promoCode == null || promoCode == undefined) { } else {
            this._service.applyPromoCode(this.productId, promoCode, this.quantity).subscribe((data) => {
                this.promoReturn = new Promoreturnmodal();
                this.promoReturn = data as Promoreturnmodal;
                this.amountToBePaid = this.promoReturn.amountToBePaid;
                if (this.promoReturn.isValid) {
                    this.promoFlag = true;
                    this.promoMessage = this.promoReturn.returnMessage;
                    this.discountAmount = this.promoReturn.discountAmount;
                    this.amountToBePaid = this.promoReturn.amountToBePaid;
                }
            });
        }
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    emailCheck() {
        this.emailProcessing = true;
        this._service.checkEmailIsValid(this.emailId.toLowerCase()).subscribe((x) => {
            this.emailReturn = x;
            this.emailProcessing = false;
            this.emailIsValid = this.emailReturn;
        });
    }
    // log(x) {

    // }
    onPaypalProceed(form) {

        this.proceedBtnDisable = true;
        this.transactionModal.status = true;
        this.showSmallSpin = true;
        let printContents;
        // var dataa: HTMLElement;
        printContents = document.getElementById('pdfdataTosend').innerHTML;
        let pdfData = "<html><head></head><body >" + printContents + "</body></html>";
        let finalModal: FinalProductPaymentModal = new FinalProductPaymentModal(this.paypalPaymentData, this.buyIpsProductReturnFinal, pdfData, this.recurringValue, "");




        this._service.createUserAfterPayment(finalModal).subscribe((data) => {
            this.showSmallSpin = false;
            this.confirmNotification = true;
            if (data["userCreated"] !== undefined && data["userCreated"] !== null) {
                if (data["userCreated"] == true) {
                    this.confirmationMessageStatus = true;
                    $("#notificationModal_buy").modal('show');
                    this.notificationText = "User Registered";
                    this.notificationTextNote = "Detailed Information  has been sent to registered mail address ";
                }
            } else {
                this.confirmationMessageStatus = false;

            }
            form.reset();
        });
    }

    onPaypalCancel() {
       

        this.canGoBack = true;
        this.planErrorMessage = "";
        document.getElementById('paypal-button-container').style.display = "none";
        this.paypalConfirmed = false;
        this.planId = "";
        this.proceed = false;
        this.paypalPaymentData = new PaypalPaymentModal();
        this.transactionModal = new TransactionModal();
    }

    makeRandomId() {
        let dateOne = new Date().getTime(); //Timestamp
        let dateTwo = (performance && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; //random number between 0 and 16
            if (dateOne > 0) { //Use timestamp until depleted
                r = (dateOne + r) % 16 | 0;
                dateOne = Math.floor(dateOne / 16);
            } else { //Use microseconds since page-load if supported
                r = (dateTwo + r) % 16 | 0;
                dateTwo = Math.floor(dateTwo / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    configurationValue = {
        createSubscription: (data, actions) => {
            return actions.subscription.create({
                'plan_id': this.planId,
            });
        },
        onApprove: (data, actions) => {
            document.getElementById('paypal-button-container').style.display = "none";

            this.paypalPaymentData.paypalTransactionId = data.subscriptionID;
            // this.transactionModal.Status = true;
            let printContents;
            // var dataa: HTMLElement;
            printContents = document.getElementById('pdfdataTosend').innerHTML;
            var pdfData = "<html><head></head><body >" + printContents + "</body></html>";
            this.showSmallSpin = true;

            var OrderId = data.orderID;



            let finalModal: FinalProductPaymentModal = new FinalProductPaymentModal(this.paypalPaymentData, this.buyIpsProductReturnFinal, pdfData, this.recurringValue, OrderId);


            this._service.createUserAfterPayment(finalModal).subscribe((data) => {
                this.showSmallSpin = false;
                this.confirmNotification = true;
                if (data["userCreated"] !== undefined && data["userCreated"] !== null) {
                    if (data["userCreated"] == true) {
                        this.confirmationMessageStatus = true;
                        $("#notificationModal_buy").modal('show');
                        this.notificationText = "User Registered";
                        this.notificationTextNote = "Detailed Information  has been sent to registered mail address ";
                    }
                } else {
                    this.confirmationMessageStatus = false;
                }
            });

        },

        onCancel: (data) => {
            // Show a cancel page, or return to cart
            this.transactionModal.paymentId = "";
            this.transactionModal.status = false;
            // Show a cancel page or return to cart
            this.showSmallSpin = true;
            var pdfdata = null;
            this.confirmationMessageStatus = false;
            this.confirmNotification = true;
            this.showSmallSpin = false;
            $("#notificationModal_buy").modal('show');
            this.notificationText = "Payment Cancelled";
            this.notificationTextNote = "Payement Is Cancelled By User";
        },

        onError: (err) => {
            // Show an error page here, when an error occurs
            this.transactionModal.paymentId = "";
            this.transactionModal.status = false;
            this.showSmallSpin = true;
            var pdfdata = null;
            this.confirmationMessageStatus = false;
            this.confirmNotification = true;
            this.showSmallSpin = false;
            $("#notificationModal_buy").modal('show');
            this.notificationText = "Error Occured  .. Please Try again!!!";
            this.notificationTextNote = "Error Occured .. Please Try again!!!";
        },
    };


    addPaypalScript() {
        this.addScript = true;
        return new Promise((resolve, reject) => {
            let scripttagElement = document.createElement('script');
            scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
            scripttagElement.onload = resolve;
            document.body.appendChild(scripttagElement);
        })
    }

    addPaypalScriptRecurring() {
        this.addScriptReccur = true;
    }

    closeNotification() {
        this.confirmNotification = false;
        if (this.confirmationMessageStatus == true) {
            $("#notificationModal_buy").modal('hide');
            this.router.navigate(['BuyIPSProduct']);
        } else {
            $("#notificationModal_buy").modal('hide');
        }
    }

    goBack() {
        if (this.canGoBack) {
            var promoNameLocal = "";
            if (this.promoReturn == undefined || this.promoReturn == null) {
                promoNameLocal = "";
            } else {
                promoNameLocal = this.promoReturn.promoName;
            }
            this.router.navigate(['BuyIPSProductPromo'], {
                queryParams: {
                    'promoId': this.promoId,
                    'productSelected': this.productId,
                    'productQty': this.quantity,
                    'promoName': promoNameLocal,
                    'addOnPrevious': this.addOnArray,
                    'addOnPreviousCcomplete': this.addonArrayComplete,
                    'BuyProductModalSent': JSON.stringify(this.buyProductFinal)
                },
                skipLocationChange: true
            });
        }
    }

    routeBackMain() {
        this.router.navigate(['login']);
    }

    onSubmit(form) {

        this.paypalPlanSubscription = null;
        this.canGoBack = false;
        this.planErrorMessage = "";
        this.trialAmount = 0;
        this.fixedAmount = 0;
        this.amountWithDiscount = "0";
        if (this.promoReturn == null || this.promoReturn == undefined) {
            this.amountWithDiscount = "0";
        } else {
            this.amountWithDiscount = this.promoReturn.discountAmount == null ? "0" : this.promoReturn.discountAmount == undefined ? "0" : this.promoReturn.discountAmount.toString();
        }
        this.paypalPaymentData = new PaypalPaymentModal();
        this.transactionModal = new TransactionModal();
        this.paypalPaymentData.productId = this.productId;
        this.paypalPaymentData.hospitalName = this.hospitalName;
        this.paypalPaymentData.mobileNo = this.mobileNo;
        this.paypalPaymentData.name = this.customerName;
        var productType;
        var validDays;
        if (this.product == null || this.product == undefined) {
            productType = 0;
        } else {
            productType = this.product.productType;
        }
        if (this.promoReturn == null || this.promoReturn == undefined) {
            validDays = 365;
        } else {
            validDays = this.promoReturn.licenseDays;;
        }

        this.paypalPaymentData.productType = productType;
        this.paypalPaymentData.validDevices = this.quantity;
        this.paypalPaymentData.amount = this.amountToBePaid;
        this.paypalPaymentData.emailId = this.emailId;
        this.paypalPaymentData.hospitalAddress = this.customerAddress;
        this.paypalPaymentData.promoId = this.promoId;
        this.paypalPaymentData.validDays = validDays;
        if (this.promoReturn !== null && this.promoReturn !== undefined) {
            this.paypalPaymentData.licenseType = this.promoReturn.licenseType;
        } else {
            this.paypalPaymentData.licenseType = 2;
        }
        this.transactionModal.amountRecieved = this.amountToBePaid;
        this.transactionModal.discountAmount = this.discountAmount;
        this.transactionModal.invoiceId = this.invoiceId;
        this.transactionModal.productId = this.productId;
        this.transactionModal.promoId = this.promoId;
        this.transactionModal.quantity = this.quantity;
        this.transactionModal.totalAmount = this.totalAmount;
        this.transactionModal.addedServices = JSON.stringify(this.addOnArray);
        this.paypalConfirmed = true;
        // if (this.amountToPay > 0) {
        if (this.recurringValue == false) {
            this.proceed = false;
        }
        //recurring
        else {
            // document.getElementById('paypal-checkout-btn').style.display = "none";
            // document.getElementById("myBtn").setAttribute('disabled', 'disabled');
            this.paypalLoad = true;
            this.trialAmount = this.amountToPay;
            this.fixedAmount = parseFloat(this.subtotal.toString()) + parseFloat(this.servicesCost.toString()) + parseFloat((((parseFloat(this.subtotal.toString()) + parseFloat(this.servicesCost.toString())) * 6.25) / 100).toString());
            this.paypalPaymentData.trialAmount = this.trialAmount.toString();
            this.paypalPaymentData.fixedAmount = this.fixedAmount.toString();
            let payPalKey: string = null;
            this.canGoBack = false;
            this._service.payPalBasicDetails().subscribe((data) => {
                
                payPalKey = data as string;
                // tslint:disable-next-line: no-shadowed-variable
            }, error => {
            this.canGoBack = true;
                console.log('Paypal ' + error.error[0]); payPalKey = null;
            },
                () => {
                    if (payPalKey != undefined) {
                        if (payPalKey != '') {
                         
                            this._service.payPalToken(payPalKey).subscribe((data1) => {
                                // localStorage.setItem('paypal', btoa(JSON.stringify(data1)));
                              
                                payPalKey = JSON.stringify(data1);
                                var jsonData = data1 as JsonPipe;
                                var token = jsonData['access_token']

                                console.log("Token Generated " + data1)
                                var mproduct = new MPaypalProduct(this.paypalPaymentData.name + " Product", "Recurring product for " + this.paypalPaymentData.hospitalName, "SERVICE", "SOFTWARE");

                                this._service.createPaypalProduct(token, mproduct).subscribe((result) => {

                                    var response = result as JsonPipe
                                    var prodId = response['id']
                                    console.log("Product Created " + result)

                               this._service.createPaypalPlan(token, prodId, this.paypalPaymentData.name + " Plan", " recurring plan for " + this.paypalPaymentData.hospitalName, Number(this.paypalPaymentData.trialAmount), Number(this.paypalPaymentData.fixedAmount)).subscribe(response => {

                                        console.log("Plan Created " + result)
                                        var plan = response as PayPalPlan


                                        this._service.savePlan(plan).subscribe(data => {
                                            console.log("Plan Saved to database  " + result)

                                            this.planId = plan.id;


                                            if (this.planId != null && this.planId != undefined && this.planId != '') {
                                                if (this.paypalConfirmed) {
                                                    this.onFormValidRecurring(this.planId, this.paypalPaymentData);
                                                    document.getElementById('paypal-button-container').style.display = "block";
                                                }
                                               
                                            } else {
                                                //	this.canGoBack=true;
                                                this.paypalLoad = false;
                                                this.planErrorMessage = "";
                                                this.planErrorMessage = data["Message"];

                                            }
                                        }, eror => {
                                            this.canGoBack = true;

                                            console.log("Failed to save plan to database  " + result)
                                        })

                                    }, err => {
                                        this.canGoBack = true;

                                        console.log("Error in Plan Creation" + err)
                                    })

                                }, err => {
                                    this.canGoBack = true;
                                    console.log("Error in Product Creation" + err)
                                })
                            }, error1 => payPalKey = null, () => {

                                if (payPalKey != undefined || payPalKey != null || payPalKey != '') {
                                    //	this.canGoBack=true;
                                    console.log(payPalKey);
                                }
                            },

                            );

                        }
                    }
                });
            /////////////////////////////          
            // this._service.createProductAndPlanForNewHa(this.paypalPaymentData).subscribe((data) => {
            //   this.planId = data["PlanId"] as string;

            //   if (this.planId != null && this.planId != undefined && this.planId != '') {
            //     this.onFormValidRecurring(this.planId, this.paypalPaymentData);
            //     document.getElementById('paypal-button-container').style.display = "block";
            //   } else {
            //     this.paypalLoad = false;
            //     this.planErrorMessage = "";
            //     this.planErrorMessage = data["Message"];

            //   }
            // },error=>{  
            // // console.log("PAYPAL"+error.error[0]);
            // if(error.error.length > 0){
            //   AlertMessages.Show('Failed',error.error[0],AlertType.Error); 
            // }

            // });
            // this.proceed = false;
        }

    }


    GetPaypalToken(): string {
        let payPalKey: string = null;

        return payPalKey;
    }

    onFormValidRecurring(planId, paypalPaymentData: PaypalPaymentModal) {
        if (!this.addScriptReccur) {
            this.addPaypalScriptRecurring();
            paypal.Buttons(this.configurationValue).render('#paypal-button-container');
        }
        this.paypalLoad = false;
    }

    gettransactionId
}
